import React from 'react';
import type { Organization } from '@types';
import 'flag-icons/css/flag-icons.min.css';
import { clientDashboardCountries } from '../utils/clientDashboardCountries';

const CountryDashboardCards: React.FC<{
    organization: Organization;
    deliveredCountries: string[];
    onOpen: (iso3: string) => void;
}> = ({ organization, deliveredCountries, onOpen }) => {
    const countries = clientDashboardCountries(organization, deliveredCountries);
    return <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" aria-label="Country dashboards">
        <h2 className="text-xl font-bold text-slate-900">Country Dashboards</h2>
        <p className="mt-1 text-sm text-slate-600">Open a country to see its requests, reports, feeds, and risks.</p>
        {countries.length ? <div className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {countries.map(country => <button key={country.iso3} type="button" onClick={() => onOpen(country.iso3)}
                className="flex w-full items-center gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 text-left transition hover:border-blue-400 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
                <span className={`fi fi-${country.iso2.toLowerCase()} shrink-0 rounded-sm shadow-sm`} role="img" aria-label={`${country.name} flag`} />
                <span className="text-base font-bold text-slate-900">{country.name}</span>
                <span className="ml-auto text-slate-400" aria-hidden="true">→</span>
            </button>)}
        </div> : <p className="mt-5 text-sm text-slate-500">Add a country location to open its dashboard.</p>}
    </section>;
};

export default CountryDashboardCards;
